import "../styles/styles.css";

import Validator from "../components/account/validator";
import { FC, useEffect, useState } from "react";
import { ajaxRefreshToken } from "../core/services/authenticationService";
import inMemoryJwtService from "../core/services/inMemoryJwtService";
import React from "react";
import { graphql } from "gatsby";

// styles
const pageStyles = {
    color: "#232129",
    // padding: 96,
    fontFamily: "-apple-system, Roboto, sans-serif, serif",
}

// markup
const Index = () => {
    const [isAppReady, setIsAppReady] = useState(true);

    useEffect(() => {
        ajaxRefreshToken()
            .then((res: any) => {
                const { token, tokenExpiration } = res;
                inMemoryJwtService.setToken(token, tokenExpiration);
                setIsAppReady(true);
            }).catch(() => {
                setIsAppReady(true);
            });
    }, []);

    return (
        <main style={pageStyles}>
            <title>KTI Promo Admin</title>
            {/* <Navbar /> */}
            <>
                {
                    isAppReady ?
                        <Validator key={1} />
                        :
                        <div>Loading...</div>
                }
            </>
        </main>
    )
}


export default Index
